import { useState, useEffect } from 'react'
import { Stack, Select, Skeleton } from '@mantine/core'
import { IconDatabaseOff } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { useCurrentTenant } from '@/store/auth'
import { databaseApi } from '@/api/database'
import { MetricsTrendChart } from '@/components/charts/MetricsTrendChart'
import { EmptyState } from '@/components/ui'
import { EstadoDeConsulta } from '@/components/ui/EstadoDeConsulta'

export function CapacityTab() {
  const tenant = useCurrentTenant()
  const tenantId = tenant?.id

  const [selectedDb, setSelectedDb] = useState<string | null>(null)

  const instancesQuery = useQuery({
    queryKey: ['rds-instances', tenantId],
    queryFn: () => databaseApi.listInstances(tenantId!),
    enabled: !!tenantId,
    staleTime: 60_000,
  })

  // Auto-select first instance
  useEffect(() => {
    if (instancesQuery.data?.items?.length && !selectedDb) {
      setSelectedDb(instancesQuery.data.items[0].db_identifier)
    }
  }, [instancesQuery.data, selectedDb])

  const instances = instancesQuery.data?.items ?? []

  return (
    <Stack gap="md">
      {/* Antes: `?? []` e, se vazio, "Nenhuma instancia encontrada" — com a API fora do ar a tela
        afirmava que o tenant nao tem instancia, e mandava configurar o acesso AWS. Podia ser o
        acesso ja configurado e a consulta falhando. */}
      <EstadoDeConsulta
        consulta={instancesQuery}
        carregando={<Skeleton width={300} height={36} />}
        vazio={instances.length === 0}
        estadoVazio={
          <EmptyState
            size="md"
            accent="primary"
            icon={IconDatabaseOff}
            title="Nenhuma instância encontrada"
            description="Configure o acesso AWS do tenant para visualizar capacidade de CPU, storage e conexões."
          />
        }
      >
        {(
        <Select
          label="Instância"
          placeholder="Selecione uma instância"
          value={selectedDb}
          onChange={setSelectedDb}
          data={instances.map((i) => ({
            value: i.db_identifier,
            label: `${i.db_identifier} (${i.engine})`,
          }))}
          w={400}
        />
      )}

      {tenantId && selectedDb && (
        <Stack gap="md">
          <MetricsTrendChart
            title="CPU Utilization"
            metric="cpu"
            tenantId={tenantId}
            dbId={selectedDb}
            accentColor="warning"
          />
          <MetricsTrendChart
            title="Storage Utilization"
            metric="storage"
            tenantId={tenantId}
            dbId={selectedDb}
            accentColor="danger"
          />
          <MetricsTrendChart
            title="Connections"
            metric="connections"
            tenantId={tenantId}
            dbId={selectedDb}
            accentColor="primary"
          />
        </Stack>
      )}
      </EstadoDeConsulta>
    </Stack>
  )
}
